export default {
  rankOrder: {
    ariaAddOption: '{label} को रैंक की गई सूची में जोड़ें',
    ariaMoveUp: '{label} को ऊपर ले जाएं',
    ariaMoveDown: '{label} को नीचे ले जाएं',
    ariaRemoveOption: '{label} को रैंक की गई सूची से हटाएं',
  },
  coe: {
    ariaDisclaimer: 'सूचना',
    ariaQuestion: 'प्रश्न',
    ariaConversationHistory: 'बातचीत का इतिहास',
    ariaYourResponse: 'आपका उत्तर {number}',
    ariaFollowUpQuestion: 'अनुवर्ती प्रश्न {number}',
    ariaResponseInput: 'उत्तर इनपुट',
    ariaRespondingTo: 'उत्तर दे रहे हैं',
    ariaSendResponse: 'उत्तर भेजें',
    ariaThinking: 'सोच रहा है'
  },
  deviceView: {
    toolbar: 'पूर्वावलोकन डिवाइस',
    mobile: 'मोबाइल',
    tablet: 'टैबलेट',
    desktop: 'डेस्कटॉप'
  },
  header: {
    customLogoAlt: 'लोगो',
    defaultLogoAlt: 'QuestDIY लोगो'
  }
}
